import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
  checkRateFailed,
  checkRateSuccessful,
  DisneyTicketsActions,
  setSelectedRate,
} from './disney-tickets.actions';
import { Store } from '@ngrx/store';
import { selectRateToCheck } from './disney-tickets.selectors';
import { DisneyService } from '@core/services';
import { AppState } from '../app.reducer';
import { ActionsSelectedPlanService } from '../../containers/tickets/services/actions-selected-plan.service';
import { Rate } from '@core/models/Rate/Rate.model';
import { of } from 'rxjs';

@Injectable()
export class DisneyTicketsEffects {
  constructor(
    private actions$: Actions,
    private readonly store: Store<AppState>,
    private readonly disneyService: DisneyService,
    private readonly actionsService: ActionsSelectedPlanService,
  ) {}

  checkRate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DisneyTicketsActions.CHECK_SELECTED_RATE),
      withLatestFrom(this.store.select(selectRateToCheck)),
      switchMap(([action, { startDate, ticketSelected }]) => {
        this.actionsService.showLoader();
        if (startDate === null) {
          return of((action as any).rate);
        }


        return this.disneyService
          .firstDay((action as any).rate.id, ticketSelected.description, startDate ,(action as any).rate.price.currency.code)
          .pipe(
            map((rate: Rate) => {
              // Preserve the meal plan tha was parsed on the original rate
              rate.checked = true;
              rate.meal_plan.description = (action as any).rate.meal_plan.description;
              this.store.dispatch(checkRateSuccessful());
              return rate;
            }),
            catchError(() => {
              this.store.dispatch(checkRateFailed());
              return of((action as any).rate);
            }),
          );
      }),
      map((rate: Rate) => {
        this.actionsService.hideLoader();
        return setSelectedRate({ rate });
      }),
    ),
  );
  
}
